import { capitalizeFirstLetter } from "./capitalizeFirstLetter"

export function transformText(text: string) {
  return text
    .split("_")
    .map((word: string) => capitalizeFirstLetter(word))
    .join(" ")
}
